import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"card-body d-flex text-center justify-content-center align-text-end\"><div class=\"row\"><div class=\"col-12\"><div class=\"fw-boldest text-center text-gray-600 fs-1 mb-2\"> มีรายการสินค้าใหม่<br>เข้ามาในวันนี้ใช่ไหม ? </div></div><div class=\"col-12\"><div class=\"d-flex text-center justify-content-center align-text-end\"><img src=\"https://preview.keenthemes.com/seven-html-pro/assets/media/svg/illustrations/easy/1.svg\" width=\"300px\" alt=\"\"></div></div></div></div>", 1)
const _hoisted_2 = { class: "card-footer" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col text-end" }
const _hoisted_5 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"]),
    style: {"height":"603px"}
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToProduct())),
            class: _normalizeClass([`btn-${_ctx.currentColor}`, "btn btn-sm btn-info fw-boldest fs-6"])
          }, "เพิ่มสินค้า", 2)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToWarehouse())),
            class: _normalizeClass([`btn-${_ctx.currentColor}`, "btn btn-sm btn-secondary fw-boldest fs-6"])
          }, "คลังสินค้า", 2)
        ])
      ])
    ])
  ], 2))
}